export const formattedAutociteSource = (source: string) =>
  ['webpage', 'article-journal'].includes(source) ? 'website' : source
